import { useMemo } from 'react'

import { useI18n } from '@runtime/core/i18n/i18n'
import TabbedCharacterHelpModal from '@/features/help/components/TabbedCharacterHelpModal'

type OnlineHelpModalProps = {
  open: boolean
  onClose: () => void
}

export default function OnlineHelpModal({ open, onClose }: OnlineHelpModalProps) {
  const { t } = useI18n()

  const tabs = useMemo(
    () => [
      {
        id: 'what',
        label: t('online.help.how.tabs.what'),
        content: t('online.help.how.what'),
      },
      {
        id: 'connect',
        label: t('online.help.how.tabs.connect'),
        content: t('online.help.how.connect'),
      },
      {
        id: 'join',
        label: t('online.help.how.tabs.join'),
        content: t('online.help.how.join'),
      },
      {
        id: 'room',
        label: t('online.help.how.tabs.room'),
        content: t('online.help.how.room'),
      },
      {
        id: 'troubleshoot',
        label: t('online.help.how.tabs.troubleshoot'),
        content: t('online.help.how.troubleshoot'),
      },
    ],
    [t],
  )

  return (
    <TabbedCharacterHelpModal
      open={open}
      character="detective"
      title={t('online.help.how.title')}
      tabs={tabs}
      onClose={onClose}
    />
  )
}
